import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { CarePlanAddComponent } from './care-plan-add.component';
import {
  MatDatepickerModule, MAT_DATE_LOCALE, MatSelectModule,
  MatFormFieldModule, MatNativeDateModule, MatInputModule
} from '@angular/material';
import { IonicModule } from '@ionic/angular';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { TranslateModule } from '../../../shared/translate/translate.module';
import { ModalsModule } from '../../../widgets/entry-components/modal/modals.module';

@NgModule({
  declarations: [CarePlanAddComponent],
  imports: [
    CommonModule,
    IonicModule,
    MatDatepickerModule,
    MatSelectModule,
    MatFormFieldModule,
    MatNativeDateModule,
    MatInputModule,
    FormsModule,
    ReactiveFormsModule,
    TranslateModule,
    ModalsModule
  ],
  exports: [
    CarePlanAddComponent
  ],
  providers: [
    MatDatepickerModule,
    { provide: MAT_DATE_LOCALE, useValue: 'hu-HU' }
  ]
})
export class CarePlanAddModule { }
